import React, { useState } from "react";
import { User, Users } from "lucide-react";

const PurposeSelection = ({ onSelect }) => {
  const [selected, setSelected] = useState(null);

  const options = [
    {
      id: "myself",
      label: "MySelf",
      icon: <User className="w-8 h-8" />,
      description: "I am seeking help for myself.",
    },
    {
      id: "family",
      label: "MyFamily / Caregiver",
      icon: <Users className="w-8 h-8" />,
      description: "I am helping a family member or acting as a caregiver.",
    },
  ];

  const handleSelect = (option) => {
    setSelected(option.id);
    if (onSelect) {
      onSelect(option.id);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-50 to-sky-100 p-4">
      <div className="bg-white rounded-2xl shadow-lg p-6 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-blue-600">
          What brings you to Aica Health?
        </h1>
        <p className="text-gray-600 mt-2">
          Please choose carefully as you may not be able to edit later.
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {options.map((option) => (
            <button
              key={option.id}
              onClick={() => handleSelect(option)}
              className={`flex flex-col items-center justify-center rounded-xl border p-6 hover:shadow-lg transition 
                ${selected === option.id ? "border-blue-500 bg-blue-50" : "border-gray-300"}
              `}
            >
              <div className="text-blue-600">{option.icon}</div>
              <h2 className="text-xl font-semibold mt-2">{option.label}</h2>
              <p className="text-gray-500 text-sm mt-1">{option.description}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PurposeSelection;
